import { useCopilotAction } from '@copilotkit/react-core'
import { F0HILActionConfirmation } from '@factorialco/f0-react'

import i18n from 'modules/core/lib/i18n'

const respondToMutationApproval = (
  respond: (message: string) => void,
  approvalId: string,
  status: 'confirmed' | 'rejected',
  runId?: string
) => {
  respond(JSON.stringify({ approvalId, status, ...(runId ? { runId } : {}) }))
}

/**
 * Confirm or reject a pending mutation that requires human approval.
 */
export const useApproveMutationAction = () => {
  useCopilotAction({
    name: 'approveMutation',
    description:
      'This action is only called when the user needs to approve or reject a mutation that is ready to run.',
    followUp: true,
    available: 'remote',
    parameters: [
      {
        name: 'approvalId',
        description: 'The unique identifier of the approval request.',
        required: true,
      },
      {
        name: 'runId',
        description: 'The workflow run id that must be resumed after approval.',
        required: true,
      },
    ],
    renderAndWaitForResponse: ({ status, args, respond }) => {
      if (status !== 'executing') {
        return <></>
      }

      return (
        <F0HILActionConfirmation
          confirmationText={i18n.t('common.confirm')}
          onConfirm={() =>
            respondToMutationApproval(respond, args.approvalId, 'confirmed', args.runId)
          }
          cancelText={i18n.t('common.cancel')}
          onCancel={() =>
            respondToMutationApproval(respond, args.approvalId, 'rejected', args.runId)
          }
        />
      )
    },
  })
}
